import React from 'react';

import { AnalyticsProvider } from '@backrs_ui/common-ui';

interface RootAnalyticsProviderProps {
  children: React.ReactNode;
}

export const RootAnalyticsProvider: React.FC<RootAnalyticsProviderProps> = ({ children }) => {
  const apiKey = process.env.REACT_APP_POST_HOG_PROJECT_API_KEY;
  const defaultApiHost = process.env.REACT_APP_POSTHOG_API_HOST;
  const analyticsEnabled = process.env.REACT_APP_ANALYTICS_ENABLED === 'true';
  const defaultUiHost = process.env.REACT_APP_POSTHOG_UI_HOST;

  return (
    <AnalyticsProvider
      apiKey={apiKey}
      apiHost={defaultApiHost}
      enabled={analyticsEnabled}
      uiHost={defaultUiHost}
      options={{
        person_profiles: 'always',
      }}
    >
      {children}
    </AnalyticsProvider>
  );
};
